import { Component, Injectable, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { Response } from '@angular/http';

import { AdministrationService } from 'app/services/administration.service';
import { AlertService } from 'app/utils/alert.service';
import { DataPackUserManagerModel } from 'app/models/data.manager.model';
import { DataPackGroup } from 'app/models/dataPackGroup.model';
import { CarrierMember } from 'app/models/carrier.model';
import { ServiceMember } from '../../../../../app/models/serviceMember.model';
import { BindComponentService } from '../../../../../app/utils/bind.component.service';
import { LoadingComponent } from '../../../../../app/home/paraEmpresas/modalLoading/content.component';
import { RemoveServiceMemberComponent } from '../../../../../app/home/paraEmpresas/administration/abbreviatedDialing/remove/content.component';

  import * as _ from "lodash";

@Component({
  selector: 'abbreviatedDialingComponent',
  templateUrl: './content.modal.template.html',

})

/**
 * @version $Id: content.component.ts 80218 2018-02-24 04:01:37Z edivaldo.m.junior $
 */
@Injectable()
export class AbbreviatedDialingComponent {

  @Input() serviceName: string;
  @Input() contractNumber: string;
  @Input() serviceMemberList: Array<ServiceMember>;
  @Input() carrierList: Array<CarrierMember>;
  @Input() preferentialCSP: CarrierMember;

  private members: Array<ServiceMember> = [];
  private form: FormGroup;
  private saving: boolean;
  private originalMemberList: Array<ServiceMember>;
  private memberListSnapshot: Array<ServiceMember>;
  private ramalPattern: string = '^[2-8][0-9]{3}$'; 
  private realNumberPattern: string = '(^0[0-9]{2})9?[0-9]{8}$'; 
  private msisdnPattern: string = '^0\\d{11}$'; 
  private editingMember: boolean = false; 
  private editingCSP: boolean = false; 

  constructor(private modalService: NgbModal, private activeModal: NgbActiveModal, private formBuilder: FormBuilder, private adminService: AdministrationService, private alertService: AlertService, private bindComponent: BindComponentService) {

  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      operation: [{ value: '', disabled: false }, Validators.required],  //value: this.model.operation
      speedDial: [null,  Validators.compose([Validators.required, Validators.pattern(this.ramalPattern)])],
      realNumber: [null, Validators.compose([Validators.required, Validators.pattern(this.realNumberPattern)])],
      description: [null, Validators.compose([Validators.required, Validators.maxLength(80)])],
      date: [null]
      
    });
    this.members = _.clone(this.serviceMemberList);
  }

  private close() {
    this.activeModal.dismiss();
  }

  private createServiceMember(): ServiceMember {
    let service = new ServiceMember();
    service.name = this.form.controls['realNumber'].value;
    service.info = this.form.controls['speedDial'].value;
    service.desc = this.form.controls['description'].value;
    service.date = this.form.controls['date'].value;
    return service;
  }
  private editMember(serviceMember: ServiceMember) {
    this.editingMember = true;
    this.form.reset();
    this.form.controls['operation'].setValue(this.preferentialCSP.code);
    this.form.controls['realNumber'].setValue(serviceMember.name);
    this.form.controls['speedDial'].setValue(serviceMember.info);
    this.form.controls['description'].setValue(serviceMember.desc);
    this.form.controls['date'].setValue(serviceMember.date);
    this.form.controls['realNumber'].disable();
  }    

  private save() {
    this.saving = true;
    let payload = { 
      action:   'insertOrUpdateMember',
      editingMember:   this.editingMember,
      serviceMember: this.createServiceMember(),
      editingCSP: this.isEditingCSP(),
      preferentialCSP: this.form.controls['operation'].value,
      serviceName: this.serviceName,
      contractNumber: this.contractNumber
    }
    this.adminService.insertOrUpdateMember(payload).subscribe(
      data => {
        this.saving = false;
        this.activeModal.close();
        this.alertService.success(data['result']);
      },
      err => {
        this.saving = false;
        this.activeModal.close();
        this.alertService.error(err.result, err);
      }
    );
  }
  private openRemoveModal(serviceMember: ServiceMember) {

    this.close();
    let modalRef = this.modalService.open(RemoveServiceMemberComponent);
    modalRef.componentInstance.serviceName = this.serviceName;
    modalRef.componentInstance.contractNumber = this.contractNumber;
    modalRef.componentInstance.serviceMember = serviceMember;
    modalRef.result.then(result => this.close(), reason => null);
  }

  private isEditingCSP(): boolean {
    if (this.preferentialCSP == null || this.preferentialCSP.code == null) {
      return true;
    }else{
      return this.preferentialCSP.code != this.form.controls['operation'].value;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/administration/abbreviatedDialing/content.component.ts